// Remove null and undefined properties
const removeNullUndefined = (obj: { [key: string]: any }) =>
  Object.fromEntries(
    Object.entries(obj).filter(
      ([, value]) => value !== null && value !== undefined
    )
  );

export default removeNullUndefined;
